import { Controller } from "@hotwired/stimulus"

/**
 Checkbox Group Controller

 Controls a group of checkboxes with a master checkbox.
 When the root checkbox is toggled, all target checkboxes follow.

 @example

 <div data-controller="checkbox-group">
 <input type="checkbox" data-action="checkbox-group#toggle">
 <input type="checkbox" data-checkbox-group-target="checkbox">
 <input type="checkbox" data-checkbox-group-target="checkbox">
 </div>
 */
export default class extends Controller {
  static targets = ["checkbox"]

  toggle(event) {
    const isChecked = event.target.checked

    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
      // Dispatch change event to trigger other controllers
      checkbox.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
}
